import CommunityStyle from "./history/CommunityStyle";
import TopicList from "./community/TopicList";
import TopicDetail from "./community/TopicDetail";
import TopicComposer from "./community/TopicComposer";
import { useCommunity } from "../hooks/useCommunity";

const TABS = [
  { id: "stats", label: "Tổng quan", emoji: "📊" },
  { id: "topics", label: "Diễn đàn", emoji: "💬" },
];

export default function CommunityView({ communityStats, streak, session }) {
  const community = useCommunity();

  return (
    <div className="community-view">
      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <div style={{ fontSize: "11px", letterSpacing: "2px", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: "4px" }}>Cùng nhau</div>
        <div style={{ fontSize: "18px", fontWeight: "700", color: "var(--text-primary)" }}>Cộng đồng 1% Tốt Hơn</div>
      </div>

      {/* Sub-tabs */}
      <div className="community-tabs">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`community-tab ${community.activeTab === tab.id ? "active" : ""}`}
            onClick={() => community.setActiveTab(tab.id)}
          >
            <span className="community-tab-emoji">{tab.emoji}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Error banner */}
      {community.error && (
        <div className="community-error" onClick={() => community.setError(null)}>
          {community.error}
        </div>
      )}

      {/* Tab content */}
      {community.activeTab === "stats" && (
        <CommunityStyle communityStats={communityStats} streak={streak} />
      )}

      {community.activeTab === "topics" && (
        <>
          {community.selectedTopic ? (
            <TopicDetail
              topic={community.selectedTopic}
              loading={community.topicLoading}
              session={session}
              submitting={community.submitting}
              onBack={community.goBackToList}
              onCreateReply={community.handleCreateReply}
              onDeleteTopic={community.handleDeleteTopic}
              onDeleteReply={community.handleDeleteReply}
              onLoadDetail={community.loadTopicDetail}
            />
          ) : (
            <TopicList
              topics={community.topics}
              loading={community.topicsLoading}
              hasMore={community.hasMoreTopics}
              categoryFilter={community.categoryFilter}
              onChangeCategory={community.changeCategory}
              onLoadMore={community.loadMoreTopics}
              onSelectTopic={community.loadTopicDetail}
              onShowComposer={() => community.setShowComposer(true)}
              loadTopics={community.loadTopics}
            />
          )}

          {community.showComposer && (
            <TopicComposer
              onSubmit={community.handleCreateTopic}
              onCancel={() => community.setShowComposer(false)}
              submitting={community.submitting}
            />
          )}
        </>
      )}
    </div>
  );
}
